import cn from 'classnames';
import { Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';
import * as styles from './Notification.module.scss';

const Notification = ({ className, html }) => {
  return (
    <section className={cn(styles.root, className)}>
      <Wrapper className={styles.wrapper}>
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{
            __html: html,
          }}
        ></div>
      </Wrapper>
    </section>
  );
};

Notification.propTypes = {
  className: PropTypes.string,
  html: PropTypes.string,
};

export default Notification;
